import Header from "./Components/Header";
import MenuDesktop from "./Components/MenuDesktop";
import MenuMobile from "./Components/MenuMobile";
import Routes from "./Routes";
import GlobalStyle from "./Styles/global";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div
      style={{
        maxWidth: "1440px",
        position: "relative",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        alignContent: "center",
      }}
    >
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Header />
      <GlobalStyle />
      <Routes />
      <MenuDesktop />
      <MenuMobile />
    </div>
  );
}

export default App;
